import {Routes} from "@angular/router";
import {NoAuthGuard} from "@core/auth/guards/noAuth.guard";
import {LayoutComponent} from "./layout/layout.component";
import {AuthGuard} from "@core/auth/guards/auth.guard";
import {InitialDataResolver} from "./app.resolver";
import {EmployeesResolver} from "./modules/espace utilisateur/employees/employees.resolver";
import {ProfilesResolver} from "./modules/espace utilisateur/profiles/profiles.resolver";

const baseRoutes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: 'dashboard'},
  {path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard'},
  {path: 'signed-up-redirect', pathMatch: 'full', redirectTo: 'dashboard'},

  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      {
        path: 'sign-out',
        loadComponent: () => import('./modules/auth/sign-out/sign-out.component').then(m => m.AuthSignOutComponent)
      },
      {
        path: 'reset-password',
        loadComponent: () => import('./modules/auth/reset-password/reset-password.component').then(m => m.AuthResetPasswordComponent)
      },
    ]
  },
]
const systemeRoutes: Routes = [
  {
    path: 'system',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    loadChildren: () => import('./modules/systeme/system/system.module').then(m => m.SystemModule)
  },
  {
    path: 'mlo-attestation-config',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    loadChildren: () => import('./modules/systeme/mlo-attestation-config/mlo-attestation-config.module').then(m => m.MloAttestationConfigModule)
  },]
const administrationRoutes: Routes = [
  {
    path: 'market-level-organization',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    resolve: {
      // data: EntitiesSuperiorResolver
    },
    loadChildren: () => import('./modules/administration/market-level-organization/market-level-organization.module').then(m => m.MarketLevelOrganizationModule)
  },
  {
    path: 'companies',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    resolve: {
      // CompaniesResolver
    },
    loadChildren: () => import('./modules/administration/companies/companies.module').then(m => m.CompaniesModule)
  },
  {
    path: 'brokers',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    loadChildren: () => import('./modules/administration/points-of-sale/points-of-sale.module').then(m => m.PointsOfSaleModule)
  },
  {
    path: 'apporteurs',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    loadChildren: () => import('./modules/administration/apporteurs/apporteurs.module').then(m => m.ApporteursModule)
  },
  {
    path: 'sous-apporteurs',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    loadChildren: () => import('./modules/administration/sous-apporteurs/sous-apporteurs.module').then(m => m.SousApporteursModule)
  },
  {
    path: 'externals',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    loadChildren: () => import('./modules/administration/externals/externals.module').then(m => m.ExternalsModule)
  },
  {
    path: 'geographic',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    loadChildren: () => import('./modules/administration/geographic/geographic.module').then(m => m.GeographicModule)
  },
]
const pricingRoutes: Routes = [
  {
    path: 'indemnity-custom-tables',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    loadChildren: () => import('./modules/pricing/indemnity-custom-tables/indemnity-custom-tables.module').then(m => m.IndemnityCustomTablesModule)
  },
]
const espaceUtilisateurRoutes: Routes = [
  {
    path: 'employees',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    resolve: {
      data: EmployeesResolver
    },
    loadChildren: () => import('./modules/espace utilisateur/employees/employees.module').then(m => m.EmployeesModule)
  },
  {
    path: 'profile',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    resolve: {
      data: ProfilesResolver
    },
    loadChildren: () => import('./modules/espace utilisateur/profiles/profiles.module').then(m => m.ProfilesModule)
  },
  {
    path: 'external-users',
    canActivate: [],
    canActivateChild: [],
    data: {
    },
    loadChildren: () => import('./modules/espace utilisateur/external-users/external-users.module').then(m => m.ExternalUsersModule)
  },]

export const routes: Routes = [
  ...baseRoutes,
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: InitialDataResolver,
    },
    children: [
      {
        path: 'dashboard',
        canActivate: [],
        canActivateChild: [],
        data: {
        },
        resolve: {
          // data: DashboardResolver
        },
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      ...administrationRoutes,
      ...espaceUtilisateurRoutes,
      ...systemeRoutes,
      ...pricingRoutes,

      // 404 & Catch all
      {
        path: '404-not-found',
        pathMatch: 'full',
        loadChildren: () => import('./modules/error/error.module').then(m => m.ErrorModule),
        data: {layout: "empty"}
      },
      {path: '**', redirectTo: '404-not-found'},
    ]
  },
];
